<div
    class="tw-rounded-xl tw-border tw-border-gray-300 tw-p-2 sm:tw-p-3 tw-mx-auto tw-w-full"
>
    <div
        class="img-area tw-bg-white tw-relative tw-w-full tw-h-[187px] tw-rounded-xl tw-mb-2"
    >
        <img
            class="tw-w-[50vw] md:tw-w-[100%] tw-h-[100%] tw-mx-auto tw-border tw-rounded-xl tw-border-gray-50"
            [src]="product?.image"
            alt="Product"
        />
    </div>
    <div class="tw-flex tw-flex-col tw-items-center">
        <h3
            class="!tw-text-[12px] sm:!tw-text-[18px] !tw-h-[55px] sm:!tw-h-[82px] !tw-font-bold !tw-text-center"
        >
            {{ product.productName }}
        </h3>
    </div>

    <ng-container *ngIf="showMore">
        <div
            class="tw-grid tw-grid-cols-1 tw-text-center sm:tw-text-left sm:tw-grid-cols-2 tw-gap-2 tw-my-2"
        >
            <div class="tw-flex tw-flex-col tw-gap-1">
                <span
                    class="tw-bg-[#F0F2F3] tw-text-[#7B7575] tw-text-[14px] tw-rounded-sm tw-px-1 tw-py-[2px]"
                >
                    {{ "COMMON.FINANCING" | translate }}
                </span>
                <span class="tw-font-bold tw-px-1 tw-py-[2px] tw-text-[14px]">
                    RM {{ product.prodFinAmtMin | number }} -
                    <br class="tw-hidden md:tw-block" />
                    RM {{ product.prodFinAmtMax | number }}
                    <span
                        class="tw-text-[12px] tw-text-[#7B7575] tw-font-normal"
                        >{{ "NEW_PRODUCTS.STARTS_FROM" | translate }}</span
                    >
                </span>
            </div>
            <div class="tw-flex tw-flex-col tw-gap-1">
                <span
                    class="tw-bg-[#F0F2F3] tw-text-[#7B7575] tw-text-[14px] tw-rounded-sm tw-px-1 tw-py-[2px]"
                    >{{ "PRODUCT_MATCHING.PROCESSING" | translate }}</span
                >
                <span class="tw-font-bold tw-px-1 tw-py-[2px] tw-text-[14px]"
                    >{{ product?.prodTat }} ({{
                        "PRODUCT_MATCHING.WORKING_DAYS" | translate
                    }})
                </span>
            </div>
            <div class="tw-flex tw-flex-col tw-gap-1">
                <span
                    class="tw-bg-[#F0F2F3] tw-text-[#7B7575] tw-text-[14px] tw-rounded-sm tw-px-1 tw-py-[2px]"
                >
                    {{ "PRODUCT_MATCHING.TENURE" | translate }}</span
                >
                <span class="tw-font-bold tw-px-1 tw-py-[2px] tw-text-[14px]">
                    {{ product?.prodTenure }} ({{
                        "PRODUCT_MATCHING.YEARS" | translate
                    }})</span
                >
            </div>
            <div class="tw-flex tw-flex-col tw-gap-1">
                <span
                    class="tw-bg-[#F0F2F3] tw-text-[#7B7575] tw-text-[14px] tw-rounded-sm tw-px-1 tw-py-[2px]"
                >
                    {{ "PRODUCT_MATCHING.INTEREST" | translate }}</span
                >
                <span class="tw-font-bold tw-px-1 tw-py-[2px] tw-text-[14px]"
                    >{{ "PRODUCT_MATCHING.FROM" | translate }}
                    {{ product?.prodInterestRate }}%
                    {{ "PRODUCT_MATCHING.PA" | translate }}</span
                >
            </div>
        </div>
    </ng-container>
    <button
        class="tw-cursor-pointer tw-mx-auto tw-flex tw-items-center tw-justify-center tw-my-2 tw-text-[12px] sm:tw-text-[14px] tw-text-gray-500"
        (click)="toggleDesc()"
    >
        {{
            showMore
                ? ("PRODUCT_MATCHING.SHOW_LESS" | translate)
                : ("PRODUCT_MATCHING.SHOW_MORE" | translate)
        }}
        <mat-icon>{{ showMore ? "expand_less" : "expand_more" }}</mat-icon>
    </button>

    <hr />

    <div class="tw-my-3 tw-flex tw-flex-col tw-gap-3 tw-items-center">
        <span class="tw-text-[12px] tw-text-[#4B6EEC] tw-font-semibold">
            {{ "FINANCING_CALCULATOR.MONTHLY_REPAYMENT" | translate }}
        </span>

        <span class="tw-font-bold tw-text-[16px] sm:tw-text-[20px]"
            >RM {{ monthlyRepayment | number : "1.2-2" }}</span
        >
        <button
            [attr.ga-event-id]="gaEventId"
            [attr.ga-event-category]="gaEventCategory"
            [attr.ga-event-label]="gaEventLable"
            ga-track="track"
            (click)="checkEligibility()"
            [ngClass]="
                isSelected
                    ? 'tw-bg-blue-900 hover:tw-bg-blue-950'
                    : 'tw-bg-[#4B6EEC] hover:tw-bg-blue-600'
            "
            class="tw-text-white tw-py-2 sm:tw-py-3 tw-px-3 sm:tw-px-5 disabled:tw-bg-[#A2A2A2] tw-text-[12px] sm:tw-text-[16px] tw-flex tw-items-center tw-text-center tw-justify-center tw-gap-2 tw-font-bold tw-rounded-full tw-cursor-pointer tw-transition-all"
        >
            <svg
                width="19"
                height="22"
                viewBox="0 0 19 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M4.84091 10.1538H14.6591C14.8761 10.1538 15.0842 10.0647 15.2376 9.90601C15.3911 9.74733 15.4773 9.53211 15.4773 9.30769V4.23077C15.4773 4.00636 15.3911 3.79113 15.2376 3.63245C15.0842 3.47376 14.8761 3.38462 14.6591 3.38462H4.84091C4.62391 3.38462 4.41581 3.47376 4.26237 3.63245C4.10893 3.79113 4.02273 4.00636 4.02273 4.23077V9.30769C4.02273 9.53211 4.10893 9.74733 4.26237 9.90601C4.41581 10.0647 4.62391 10.1538 4.84091 10.1538ZM5.65909 5.07692H13.8409V8.46154H5.65909V5.07692ZM17.1136 0H2.38636C1.95237 0 1.53616 0.178296 1.22928 0.495665C0.922402 0.813035 0.75 1.24348 0.75 1.69231V20.3077C0.75 20.7565 0.922402 21.187 1.22928 21.5043C1.53616 21.8217 1.95237 22 2.38636 22H17.1136C17.5476 22 17.9638 21.8217 18.2707 21.5043C18.5776 21.187 18.75 20.7565 18.75 20.3077V1.69231C18.75 1.24348 18.5776 0.813035 18.2707 0.495665C17.9638 0.178296 17.5476 0 17.1136 0ZM17.1136 20.3077H2.38636V1.69231H17.1136V20.3077ZM6.88636 13.1154C6.88636 13.3664 6.81439 13.6118 6.67953 13.8205C6.54468 14.0293 6.353 14.1919 6.12875 14.288C5.90449 14.3841 5.65773 14.4092 5.41966 14.3602C5.18159 14.3113 4.96291 14.1904 4.79128 14.0129C4.61964 13.8354 4.50275 13.6092 4.4554 13.363C4.40805 13.1168 4.43235 12.8616 4.52524 12.6297C4.61813 12.3977 4.77543 12.1995 4.97725 12.0601C5.17908 11.9206 5.41636 11.8462 5.65909 11.8462C5.98458 11.8462 6.29675 11.9799 6.5269 12.2179C6.75706 12.4559 6.88636 12.7788 6.88636 13.1154ZM10.9773 13.1154C10.9773 13.3664 10.9053 13.6118 10.7704 13.8205C10.6356 14.0293 10.4439 14.1919 10.2197 14.288C9.9954 14.3841 9.74864 14.4092 9.51057 14.3602C9.2725 14.3113 9.05382 14.1904 8.88219 14.0129C8.71055 13.8354 8.59366 13.6092 8.54631 13.363C8.49895 13.1168 8.52326 12.8616 8.61615 12.6297C8.70904 12.3977 8.86634 12.1995 9.06816 12.0601C9.26999 11.9206 9.50727 11.8462 9.75 11.8462C10.0755 11.8462 10.3877 11.9799 10.6178 12.2179C10.848 12.4559 10.9773 12.7788 10.9773 13.1154ZM15.0682 13.1154C15.0682 13.3664 14.9962 13.6118 14.8613 13.8205C14.7265 14.0293 14.5348 14.1919 14.3106 14.288C14.0863 14.3841 13.8395 14.4092 13.6015 14.3602C13.3634 14.3113 13.1447 14.1904 12.9731 14.0129C12.8015 13.8354 12.6846 13.6092 12.6372 13.363C12.5899 13.1168 12.6142 12.8616 12.7071 12.6297C12.7999 12.3977 12.9572 12.1995 13.1591 12.0601C13.3609 11.9206 13.5982 11.8462 13.8409 11.8462C14.1664 11.8462 14.4786 11.9799 14.7087 12.2179C14.9389 12.4559 15.0682 12.7788 15.0682 13.1154ZM6.88636 17.3462C6.88636 17.5972 6.81439 17.8426 6.67953 18.0513C6.54468 18.26 6.353 18.4227 6.12875 18.5188C5.90449 18.6148 5.65773 18.64 5.41966 18.591C5.18159 18.542 4.96291 18.4211 4.79128 18.2436C4.61964 18.0661 4.50275 17.84 4.4554 17.5938C4.40805 17.3476 4.43235 17.0924 4.52524 16.8604C4.61813 16.6285 4.77543 16.4303 4.97725 16.2908C5.17908 16.1514 5.41636 16.0769 5.65909 16.0769C5.98458 16.0769 6.29675 16.2106 6.5269 16.4487C6.75706 16.6867 6.88636 17.0095 6.88636 17.3462ZM10.9773 17.3462C10.9773 17.5972 10.9053 17.8426 10.7704 18.0513C10.6356 18.26 10.4439 18.4227 10.2197 18.5188C9.9954 18.6148 9.74864 18.64 9.51057 18.591C9.2725 18.542 9.05382 18.4211 8.88219 18.2436C8.71055 18.0661 8.59366 17.84 8.54631 17.5938C8.49895 17.3476 8.52326 17.0924 8.61615 16.8604C8.70904 16.6285 8.86634 16.4303 9.06816 16.2908C9.26999 16.1514 9.50727 16.0769 9.75 16.0769C10.0755 16.0769 10.3877 16.2106 10.6178 16.4487C10.848 16.6867 10.9773 17.0095 10.9773 17.3462ZM15.0682 17.3462C15.0682 17.5972 14.9962 17.8426 14.8613 18.0513C14.7265 18.26 14.5348 18.4227 14.3106 18.5188C14.0863 18.6148 13.8395 18.64 13.6015 18.591C13.3634 18.542 13.1447 18.4211 12.9731 18.2436C12.8015 18.0661 12.6846 17.84 12.6372 17.5938C12.5899 17.3476 12.6142 17.0924 12.7071 16.8604C12.7999 16.6285 12.9572 16.4303 13.1591 16.2908C13.3609 16.1514 13.5982 16.0769 13.8409 16.0769C14.1664 16.0769 14.4786 16.2106 14.7087 16.4487C14.9389 16.6867 15.0682 17.0095 15.0682 17.3462Z"
                    fill="white"
                />
            </svg>

            {{ "FINANCING_CALCULATOR.ELEGIBILITY" | translate }}
        </button>
    </div>
</div>
